<template>
  <div class="p-4" v-if="client">

    <div class="flex justify-between items-center h-fit mb-8">
      <div class="flex w-full items-center">
        <!-- Bouton retour -->
        <button class="h-fit !m-0 !px-2 !bg-transparent flex items-center justify-center text-gray-400 !font-normal cursor-pointer" @click="$router.go(-1)">
          <i class="fa-solid fa-arrow-left "></i>
          <div class="!text-2xl">&nbsp;Clients/</div>
        </button>
        <!-- Titre -->
        <span
            class="basicInput w-1/2 text-xl text-left flex items-center truncate"
            type="text"
          >{{ client.contacts[0].firstName }} {{ client.contacts[0].lastName }}
        </span>
      </div>
    </div>

    <!-- Informations générales -->
    <div class="flex gap-4 w-full relative">
      <div
        v-if="clientsPerm != 'modification'"
        style="position:absolute;top:0;left:0;width:100%;height:100%;z-index:1000;cursor:not-allowed;background:rgba(255,255,255,0.01);"
        @mousedown.stop
        @mouseup.stop
        @click.stop
        @pointerdown.stop
        @pointerup.stop
        @touchstart.stop
        @touchend.stop
      ></div>

      <!-- Div info -->
      <div class="flex-grow flex flex-col w-full gap-8 h-fit">
        <div class="flex gap-4">
          <div class="w-4/10 text-left">
            <div class="font-semibold text-left mb-1">Nom</div>
            <input class="basicInput w-full" v-model="client.contacts[0].lastName" placeholder="Nom"/>
          </div>
          <div class="w-6/10 text-left">
            <div class="font-semibold text-left mb-1">Prénom</div>
            <input class="basicInput w-full" v-model="client.contacts[0].firstName" placeholder="Prénom"/>
          </div>
        </div>

        <div class="flex gap-4">
          <div class="w-3/5 text-left">
            <div class="font-semibold text-left mb-1">Mail</div>
            <input class="basicInput w-full" v-model="client.contacts[0].email" placeholder="email@gmail.com"/>
          </div>
          <div class="w-2/5 text-left">
            <div class="font-semibold text-left mb-1">Téléphone</div>
            <input class="basicInput w-full" v-model="client.contacts[0].phone1" placeholder="06 06 06 06 06"/>
          </div>
        </div>

        <!-- Adresse du projet -->
        <div class="flex flex-col gap-4">
          <div class="flex flex-col w-full">
            <div class="font-semibold text-left mb-1">Adresse</div>
            <input class="basicInput w-full" v-model="client.adress"/>
            <!-- <div class="text-left truncate h-6" v-else>{{ project.address }}</div> -->
          </div>
          <div class="flex gap-2">
            <div class="flex flex-col w-4/5">
              <div class="font-semibold text-left mb-1">Ville</div>
              <input class="basicInput w-full" v-model="client.city"/>
            </div>
            <div class="flex flex-col w-1/5">
              <div class="font-semibold text-left mb-1">CP</div>
              <input class="basicInput w-full" v-model="client.postalCode"/>
            </div>
          </div>
        </div>
      </div>

      <div class="border border-gray-300"></div>

      <!-- Div description -->
      <div class="flex flex-col w-full">
        <div class="font-semibold text-left mb-1">Informations notables (Réseaux, site web...)</div>
        <textarea class="basicInput px-1 flex-grow resize-none" v-model="client.description"></textarea>
      </div>

    </div>
  </div>
  
  <div class="border border-gray-300 my-4 mx-4"></div>

  <!-- Projets du client -->
  <div class="" v-if="client">
    <ShowProjects :clientId="client.id" />
  </div>

</template>

<script>

import { getClientById, updateClient } from '@/services/clientService';

import ShowProjects from '@/views/App/ShowProjects.vue';

import { inject } from 'vue';

export default {
  name: "ClientDetails",
  components: {
    ShowProjects,
  },
  data() {
    return {
      client: null,
    };
  },
  setup() {
    const perm = inject('userPerm');
    return { perm };
  },
  computed: {
    clientsPerm() {
      console.log("Clients perm", this.perm().clients);
      return this.perm().clients;
    },
  },
  async mounted() {
    this.client = await getClientById(this.$route.params.id);
    console.log("ClientDetails mounted", this.client);
  },
  watch: {
    client: {
      handler(newClient) {
        updateClient(this.client);
      },
      deep: true, // Watch for changes in nested properties
    },
  },
};
</script>